import { render, staticRenderFns } from "./hall-form.vue?vue&type=template&id=1bef4a60&scoped=true"
import script from "./hall-form.vue?vue&type=script&lang=js"
export * from "./hall-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef4a60",
  null
  
)

export default component.exports